import React from 'react';
import { Link } from 'react-router-dom';
import profileImg from './images/profile-2.png';
import pinkBlob from './images/pink-blob.png';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 sm:px-6 w-full max-w-[100vw] overflow-x-hidden">
      <section className="w-full max-w-6xl min-w-0 flex flex-col-reverse md:flex-row items-start md:items-center justify-between gap-5 md:gap-6 relative pt-3 md:pt-0 pb-8 md:pb-0">
        {/* Left: Intro */}
        <div className="flex-1 z-10 flex flex-col justify-center min-w-0 w-full">
          <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1 mb-3 sm:mb-4">
            <h1 className="text-[3rem] leading-tight sm:text-5xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 font-clean">
              Hi, I&apos;m Priya
            </h1>
            <span className="text-pastel-pink text-3xl sm:text-3xl shrink-0" aria-hidden>
              ✨
            </span>
          </div>
          <p className="text-2xl sm:text-2xl md:text-2xl text-gray-700 font-clean max-w-lg mb-8 leading-snug">
            I&apos;m a software developer based in Sydney, Australia
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-soft-pink to-soft-lavender text-white font-medium rounded-xl shadow-soft hover:shadow-lg hover:scale-105 transition-all duration-300 w-fit group"
          >
            Get In Touch
            <span className="material-icons ml-2 text-lg transition-transform duration-300 group-hover:translate-x-1">arrow_forward</span>
          </Link>
        </div>

        {/* Right: Avatar with pastel blob — fixed 600×600 artboard, scaled down on small screens */}
        <div className="flex-1 w-full min-w-0 flex justify-center md:justify-start md:min-w-0 overflow-x-clip">
          <div
            className="relative mx-auto md:mx-0
              h-[390px] w-full max-w-[540px]
              sm:h-[430px] sm:max-w-[560px]
              md:h-[400px] md:max-w-[440px]
              lg:h-[520px] lg:max-w-[560px]
              xl:h-[600px] xl:max-w-[600px]"
          >
            <div
              className="absolute left-1/2 top-0 h-[600px] w-[600px] origin-top -translate-x-1/2
                scale-[0.65] sm:scale-[0.72] md:scale-[0.67] lg:scale-[0.87] xl:scale-100"
            >
              <img
                src={pinkBlob}
                alt=""
                className="absolute object-contain opacity-70 z-0"
                style={{
                  width: '489px',
                  height: '400px',
                  left: '60px',
                  top: '98px',
                }}
              />
              <div
                className="absolute z-10"
                style={{
                  left: '146px',
                  top: '2px',
                }}
              >
                <img
                  src={profileImg}
                  alt="Profile"
                  className="object-contain object-top"
                  style={{
                    width: '367px',
                    height: '550px',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
